<div [hidden]="!loading">
  <ab-spinner></ab-spinner>
</div>
<div *ngIf="attrs">
  <ab-attr-group [attrs]="filterAttrs({ basic: true })"></ab-attr-group>
  <div class="attr-advanced">
    <ab-attr-group
      [attrs]="filterAttrs({ basic: false, custom: false })"
    ></ab-attr-group>
    <button
      class="btn btn--upgrade attr-advanced__upgrade-button"
      (click)="openUpgradeModal($event)"
      *ngIf="!features?.advanced_aggregations"
      data-feature="advanced_aggregations"
      type="button"
    >
      Enable Advanced Aggregations
    </button>
  </div>
  <div class="attr-custom">
    <div class="attr-list-subtitle">
      <h4
        *ngIf="!features?.custom_aggregations"
        (click)="openUpgradeModal($event, 3)"
        data-feature="custom_aggregations"
        ngbTooltip="This is an Advanced feature. Upgrade your plan to enable it"
        placement="top"
      >
        &#9733; Custom aggregations
      </h4>
      <h4
        *ngIf="features?.custom_aggregations"
        ngbTooltip="This is an Advanced feature included in your plan"
        placement="top"
      >
        &#9733; Custom aggregations
      </h4>
    </div>
    <ab-attr-group
      *ngIf="features?.custom_aggregations"
      [attrs]="filterAttrs({ custom: true })"
      (deleted)="deleteAttr($event)"
    ></ab-attr-group>
    <p class="attr-list-intro">
      Preview additional aggregations and pin them to the Aggregations tab of
      this error.
    </p>
    <div class="row mb-3" *ngIf="!features?.custom_aggregations">
      <div class="col-xl-12">
        <button
          class="btn btn--upgrade"
          (click)="openUpgradeModal($event, 3)"
          data-feature="custom_aggregations"
          type="button"
        >
          Enable Custom Aggregations
        </button>
      </div>
    </div>
  </div>
</div>
<ab-attr-preview
  [project]="project"
  [group]="group"
  (created)="onCreateAttr($event)"
  *ngIf="features?.custom_aggregations"
></ab-attr-preview>
